import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { UnverifiedReseller } from "../../resellers.types";
import { ApiRoutesResellers } from "./../../constants";

export const requestGetUnverifiedResellers = async (
  params: GetListRequestParams
): Promise<GetListResponse<UnverifiedReseller>> => {
  return await instance.get(ApiRoutesResellers.AllUnverifiedResellers, {
    params
  });
};
